import http from '../../../services/api'
import type { APIPaginatedResponse, APIResponse, Filters, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'

const apiPath = import.meta.env.VITE_API_PATH

export type StockOutLinePayload = {
  item_uuid: string
  quantity: number
  unit_uuid?: string
  batch_number?: string | null
  serials?: string[] | null
}

export type StockOutPayload = {
  reference_type: number
  location_id: number
  adjustment_date: string
  reference_number?: string | null
  reason?: number | null
  notes: string
  items: StockOutLinePayload[]
}

async function createStockOut(input: StockOutPayload) {
  return await http.post<APIResponse<{ lines: unknown[] }>>(apiPath + 'inventory/stock-out/out', input, {
    errorHandle: false,
  } as any)
}

async function getStockOut(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getRequestParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<Record<string, unknown>>>(apiPath + 'inventory/stock-out' + paramString, {
    errorHandle: false,
  } as any)
}

const stockOutService = {
  createStockOut,
  getStockOut,
}

export default stockOutService
